import { ButtonLink, Flex } from '@applyboard/crystal-ui';
import { PlusOutlineIcon } from '@applyboard/ui-icons';

import { PageHeader } from '../../../components/PageHeader';
import { SelectedIntakesBar } from '../components';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  QueryFilter,
  Sort,
  IntakesTable,
  StatusFilter,
} from '~/components/Intake';

export function TabletLayout() {
  return (
    <Flex p={10} gap={3} direction="column">
      <Flex justify="between" align="center">
        <PageHeader title="Intake Management" />
        <ButtonLink href="/intake-management/new" intent="primary" leadIcon={PlusOutlineIcon}>
          Add Intake
        </ButtonLink>
      </Flex>
      <Filter as={<QueryFilter />} width="100%" />
      <Flex gap={2}>
        <Filter as={<CampusFilter />} width="25%" />
        <Filter as={<IntakeFilter />} width="25%" />
        <Filter as={<StatusFilter />} width="25%" />
        <Filter as={<Sort />} width="25%" />
      </Flex>
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <SelectedIntakesBar />
      <IntakesTable />
      <IntakesPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
